import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, BarChart2, Settings, Users, Building } from 'lucide-react';
import { useAdminAccess } from '../../hooks/useAdminAccess';

export default function Sidebar() {
  const { isAdmin } = useAdminAccess();

  // Base navigation items for all users
  const baseNavigation = [
    { name: 'Dashboard', href: '/dashboard', icon: LayoutDashboard },
    { name: 'Analytics', href: '/analytics', icon: BarChart2 },
    { name: 'Settings', href: '/settings', icon: Settings },
  ];

  // Admin-only navigation items
  const adminNavigation = [
    { name: 'User Management', href: '/admin/users', icon: Users },
    { name: 'Domain Settings', href: '/admin/domain', icon: Building },
    { name: 'Billing', href: '/admin/billing', icon: BarChart2 },
  ];

  // Combine navigation items based on user role
  const navigation = [
    ...baseNavigation,
    ...(isAdmin ? adminNavigation : [])
  ];

  return (
    <div className="w-64 bg-white shadow-stickr-sm min-h-screen">
      <nav className="mt-5 px-2">
        <div className="space-y-1">
          {navigation.map((item) => (
            <NavLink
              key={item.name}
              to={item.href}
              className={({ isActive }) =>
                `group flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors ${
                  isActive
                    ? 'bg-violet/10 text-primary'
                    : 'text-gunmetal hover:bg-light-purple/10 hover:text-primary'
                }`
              }
            >
              <item.icon className="mr-3 h-5 w-5 flex-shrink-0" />
              {item.name}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}